<template>
  <path
    d="M16 1.00018H8C6.34 1.00018 5 2.34018 5 4.00018V20.0002C5 21.6602 6.34 23.0002 8 23.0002H16C17.66 23.0002 19 21.6602 19 20.0002V4.00018C19 2.34018 17.66 1.00018 16 1.00018ZM13.5 21.0002H10.5C10.22 21.0002 10 20.7802 10 20.5002C10 20.2202 10.22 20.0002 10.5 20.0002H13.5C13.78 20.0002 14 20.2202 14 20.5002C14 20.7802 13.78 21.0002 13.5 21.0002ZM17 18.0002H7V4.00018H17V18.0002Z"
  />
</template>
